import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=46930408&scoped=true"
import script from "./blogDetail.vue?vue&type=script&lang=js"
export * from "./blogDetail.vue?vue&type=script&lang=js"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=46930408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46930408",
  null
  
)

export default component.exports